<template>
  <div>
    <div style="display: flex;align-items: flex-start;justify-content:space-between;margin-top: 1em" v-for="(p, i) in list" :key="i">
      <div style="display: flex;align-items: flex-start;">
        <div style="display: flex;">
          {{p.relationPrefix}}<span :style="{marginLeft: '0.5em',width: '5em', ...underlineStyle}">{{p.relationSuffix}}</span>*
        </div>
        <div style="flex: 1;display: flex;margin-left: 0.5em;">
          姓名：<span :style="{width: '4em', ...underlineStyle}">{{p.name}}</span>*
        </div>
      </div>
      <div style="flex: 1;min-width: 0;margin-left: 0.5em;">
        <div style="display: flex">
          生：
          <span :style="{width: '6em', ...underlineStyle, textAlign: 'center'}">{{p.birth ? p.birth.year : ""}}</span>
          年
          <span :style="{flex: 1, minWidth: 0, ...underlineStyle, textAlign: 'center'}">{{p.birth ? p.birth.month : ""}}</span>
          月
          <span :style="{flex: 1, minWidth: 0, ...underlineStyle, textAlign: 'center'}">{{p.birth ? p.birth.date : ""}}</span>
          日
          <span :style="{flex: 1, minWidth: 0, ...underlineStyle, textAlign: 'center'}">{{ p.birthTimeText }}</span>
          时.
        </div>
        <div style="display: flex;margin-top: 1em;">
          卒：
          <span :style="{width: '6em', ...underlineStyle, textAlign: 'center'}">{{p.die ? p.die.year : ""}}</span>
          年
          <span :style="{flex: 1, minWidth: 0, ...underlineStyle, textAlign: 'center'}">{{p.die ? p.die.month : ""}}</span>
          月
          <span :style="{flex: 1, minWidth: 0, ...underlineStyle, textAlign: 'center'}">{{p.die ? p.die.date : ""}}</span>
          日
          <span :style="{flex: 1, minWidth: 0, ...underlineStyle, textAlign: 'center'}">{{ p.dieTimeText }}</span>
          时.
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="tsx">

    export default {
        name: "BuddhismPersonList",
        props: {
            underlineStyle: {
                type: Object,
                default() {
                    return {}
                }
            },
            list: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data() {
            return {

            }
        }
    }
</script>

<style scoped>

</style>
